import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { AuthProvider } from './context/AuthContext';
import { NotificationProvider } from './context/NotificationContext'; // NOWY IMPORT
import './i18n';

const root = ReactDOM.createRoot(
    document.getElementById('root') as HTMLElement
);

root.render(
    <React.StrictMode>
        <Suspense fallback={<div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Ładowanie...</div>}>
            {/* AuthProvider jest teraz wewnątrz NotificationProvider */}
            <NotificationProvider>
                <AuthProvider>
                    <App />
                </AuthProvider>
            </NotificationProvider>
        </Suspense>
    </React.StrictMode>
);
